<template>
  <span :class="['dh-psy-cencored', { 'dh-psy-cencored--revealed': revealed }]">
    <span style="position: relative">{{ content }}</span>
  </span>
</template>

<style lang="postcss" scoped>
  .dh-psy-cencored {
    display: inline-block;
    position: relative;
    transition: 0.52s color cubic-bezier(0.4, 0, 1, 1);
  }

  .dh-psy-cencored--revealed {
  }
</style>

<script>
import image from '../../../../assets/sladd-test-2.png'
export default {
  props: {
    revealed: {
      type: Boolean,
      required: false,
      default: false
    },
    content: String
  },
  computed: {
    image() {
      return image
    },
    classList() {
      return [{ 'dh-psy-revealed': this.revealed }, 'dh-psy-cencored__item']
    }
  }
}
</script>
